import { useEffect } from 'react'
import { useUser } from '@clerk/clerk-react'
import { TextToImageForm } from '@/components/features/images'
import { AnalyticsService } from '@/services/analytics'

export function TextToImagePage() {
  const { user } = useUser()

  useEffect(() => {
    AnalyticsService.trackViewItem('image_tools', 'text_to_image', 'Text to Image', user?.id)
    AnalyticsService.trackViewContent('Text to Image', user?.id)
  }, [user?.id])

  return (
    <div className="p-6 md:p-8 max-w-4xl mx-auto">
      <TextToImageForm />
    </div>
  )
}
